module.exports = __webpack_public_path__ + "static/revicons-1142a254da20b59e7d10ac39e78c4fbf.svg";